// local

export const environment = {
  serverPath: process.env.REACT_APP_SERVER_URL as string,
  authPath: process.env.REACT_APP_AUTH_SERVER as string,
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY as string,
  environment: process.env.REACT_APP_ENVIRONMENT as "development" | "production",
  googleOAuthClientId: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID as string,
  facebookClientId: process.env.REACT_APP_FACEBOOK_CLIENT_ID as string,
};

//sharing

// export const environment = {
//     serverPath: "https://a7fb-217-65-249-18.ngrok-free.app",
//     authPath: process.env.REACT_APP_AUTH_SERVER ? process.env.REACT_APP_AUTH_SERVER : "",
//     googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY ? process.env.REACT_APP_GOOGLE_API_KEY : "",
//     environment:  process.env.REACT_APP_ENVIRONMENT ? process.env.REACT_APP_ENVIRONMENT : "",
//     local: false
// }
